import { Heading } from "@/components/generic/Heading";
import { twMerge } from "tailwind-merge";

type Props = {
  className?: string;
  title: string;
  description?: string | React.ReactNode;
  descClassName?: string;
};

export function SegmentHeader({
  title,
  description,
  className,
  descClassName,
}: Props) {
  return (
    <div className={twMerge("flex flex-col items-center gap-y-6", className)}>
      <Heading level={2}>{title}</Heading>

      {description && (
        <p
          className={twMerge(
            "text-theme-on-background-variant text-center text-[12px] leading-5 font-medium",
            descClassName,
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
}
